import { useEffect, useState } from "react"
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AddInstructorAsync, GetInstructorAsync, RemoveInstructorAsync, selectEditFlag, selectInstructorList, setEditFlag } from "../features/add_workout/workoutSlice";
import { Button, FormControl, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import { tableDesign } from "../app/consts";

const ManageInstructors = () => {
  const dispatch = useAppDispatch();
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [PhoneNumberNotValid, setPhoneNumberNotValid] = useState<boolean>(false)
  const editFlag = useAppSelector(selectEditFlag);
  const instructors = useAppSelector(selectInstructorList);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(GetInstructorAsync())
    // eslint-disable-next-line
  }, [editFlag])

  const handleSubmit = () => {
    let noErrors = document.querySelector<HTMLInputElement>('form[id="addInstructor"]')?.checkValidity();
    if (instructors.find((value) => value.phoneNumber === phoneNumber))
      toast.error("מדריך בעל מספר הטלפון שהוזן כבר קיים");
    else if (noErrors) {
      dispatch(AddInstructorAsync({ 'fullName': firstName + " " + lastName, 'phoneNumber': phoneNumber }))
        .then(() => {
          dispatch(setEditFlag());
          toast.success("המאמן התווסף בהצלחה!"); document.forms[0].reset()
        })
        .catch((reason) => toast.error(reason))
    }
    else
      toast.error("קיימת טעות בטופס, אנא וודא את הפרטים שמולאו");
  }

  const validatePhoneNumber = (phoneNum: string) => {
    const reg = new RegExp("^05\\d{8}$");
    if (reg.test(phoneNum) === false) {
      setPhoneNumberNotValid(true)
    }
    else {
      setPhoneNumberNotValid(false)
      setPhoneNumber(phoneNum)
    }
  }

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', }}>
        <br />
        <div>
          <form id='addInstructor' method='post' onSubmit={(e) => e.preventDefault()}>
            <FormControl>
              <TextField variant="filled" label='שם פרטי' type='text' onChange={(e) => setFirstName(e.target.value)} required style={{ textAlign: 'center', width: '300px', }} />
              <br />
              <TextField variant="filled" label='שם משפחה' type='text' onChange={(e) => setLastName(e.target.value)} required style={{ textAlign: 'center', width: '300px', }} />
              <br />
              <TextField variant="filled" label='מספר טלפון נייד' type='tel' onChange={(e) => validatePhoneNumber(e.target.value)} error={PhoneNumberNotValid} required style={{ textAlign: 'center', width: '300px', }} />
              <br />
              <Button type='submit' onClick={() => handleSubmit()} variant="contained" size='large' color='success'
              >הוסף מדריך</Button>
            </FormControl>
          </form>
          <hr />
        </div>
        <div >
          {instructors.length === 0 ?
            <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', }} />
            :
            <Paper sx={tableDesign}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table" sx={{ "& .MuiTableCell-root": { fontSize: "1em", textAlign: 'center' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>פעולות</TableCell>
                      <TableCell>שם מלא</TableCell>
                      <TableCell>מספר טלפון</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {instructors?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((instructor, index) =>
                      <TableRow key={index}>
                        <TableCell><Button variant="contained" size='small' color='error' onClick={() => window.confirm(`אנא אשר את מחיקת המדריך:\n${instructor.fullName} - ${instructor.phoneNumber}`) && dispatch(RemoveInstructorAsync(+instructor.id)).then(() => dispatch(setEditFlag()))}>מחק</Button></TableCell>
                        <TableCell>{instructor.fullName}</TableCell>
                        <TableCell>{instructor.phoneNumber}</TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={instructors.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ justifySelf: 'right', direction: 'ltr' }}
              />
            </Paper>
          }
        </div>
      </div>
    </div>
  )
}

export default ManageInstructors